var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"check-box",attrs:{"for":_vm.id}},[_c('input',{attrs:{"type":"Checkbox","id":_vm.id},domProps:{"value":true},on:{"input":function($event){_vm.model = !_vm.model}}}),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }